import React from 'react';
import { styles } from './phoneStyles';

// 📱 1. 新闻 App
export const NewsApp = ({ phoneData, newsTab, setNewsTab, handleOpenDetail }) => (
  <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
    <div style={styles.appTitle}>🔥 科技热榜</div>
    <div style={{ display: 'flex', gap: 20, marginBottom: 15, borderBottom: '1px solid #333' }}>
      <div onClick={() => setNewsTab('today')} style={{ ...styles.tabBtn, borderBottom: newsTab === 'today' ? '2px solid #ff4081' : 'none', color: newsTab === 'today' ? '#ff4081' : '#888' }}>今日热榜</div>
      <div onClick={() => setNewsTab('history')} style={{ ...styles.tabBtn, borderBottom: newsTab === 'history' ? '2px solid #ff4081' : 'none', color: newsTab === 'history' ? '#ff4081' : '#888' }}>历史热点</div>
    </div>
    <div style={{ flex: 1, overflowY: 'auto', scrollbarWidth: 'none' }}>
      {newsTab === 'today' && phoneData.todayTrends?.map((trend, i) => (
        <div key={trend.id || i} style={styles.newsItem} onClick={() => handleOpenDetail('news', trend, false)}>
          <div style={{ marginBottom: 5 }}>{i + 1}. {trend.title}</div>
          <div style={{ fontSize: 11, color: '#666' }}>👁️ {trend.views} · 💬 {trend.comments}</div>
        </div>
      ))}
      {newsTab === 'history' && phoneData.historyTrends?.map((trend, i) => (
        <div key={trend.id || i} style={{ ...styles.newsItem, borderLeft: '3px solid #444', background: '#151515' }} onClick={() => handleOpenDetail('news', trend, true)}>
          <div style={{ marginBottom: 5, color: '#aaa' }}>{trend.title}</div>
          <div style={{ fontSize: 11, color: '#555' }}>👁️ {trend.views} · 💬 {trend.comments}</div>
        </div>
      ))}
    </div>
  </div>
);

// 📱 2. 短信 App
export const SmsApp = ({ phoneData, state, handleOpenDetail, getLastMessageText }) => (
  <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
    <div style={styles.appTitle}>💬 信息</div>
    <div style={{ flex: 1, overflowY: 'auto', scrollbarWidth: 'none', display: 'flex', flexDirection: 'column', gap: 10 }}>
      {phoneData.sms.filter((v, i, a) => a.findIndex(t => (t.sender === v.sender)) === i).map((msg) => (
        <div key={msg.id} style={styles.smsListItem} onClick={() => handleOpenDetail('sms', msg, false)}>
          <div style={{ ...styles.avatar, background: state.san <= 10 ? '#800000' : '#4caf50' }}>
            {state.san <= 10 ? '💀' : msg.sender.substring(0, 1)}
          </div>
          <div style={{ flex: 1, overflow: 'hidden' }}>
            <div style={{ fontSize: 13, color: state.san <= 10 ? '#f44336' : '#fff', marginBottom: 2, fontWeight: 'bold' }}>
              {state.san <= 10 ? '未知实体_0x' + Math.floor(Math.random() * 999) : msg.sender}
            </div>
            <div style={styles.textPreview}>{getLastMessageText(msg.sender)}</div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

// 📱 3. 邮件 App
export const MailApp = ({ phoneData, handleOpenDetail }) => (
  <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
    <div style={styles.appTitle}>✉️ 收件箱</div>
    <div style={{ flex: 1, overflowY: 'auto', scrollbarWidth: 'none' }}>
      {phoneData.email.map((mail) => (
        <div key={mail.id} style={styles.mailItem} onClick={() => handleOpenDetail('mail', mail, false)}>
          <div style={styles.mailSubject}>{mail.subject}</div>
          <div style={styles.mailPreview}>{mail.preview}</div>
        </div>
      ))}
    </div>
  </div>
);

// 📱 4. 股票 App
export const StocksApp = ({ state, handleTrade }) => (
  <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
    <div style={styles.appTitle}>📈 韭菜理财</div>
    <div style={{ background: '#1a1a1a', padding: 15, borderRadius: 10, marginBottom: 15 }}>
      <div style={{ fontSize: 12, color: '#aaa' }}>可用资金</div>
      <div style={{ fontSize: 24, fontWeight: 'bold', color: '#ff9800', marginTop: 5 }}>¥ {state.money.toLocaleString()}</div>
    </div>
    <div style={{ flex: 1, overflowY: 'auto', scrollbarWidth: 'none', display: 'flex', flexDirection: 'column', gap: 10 }}>
      {Object.entries(state.stocks || {}).map(([key, stock]) => {
        const prevPrice = stock.history.length > 1 ? stock.history[stock.history.length - 2] : stock.price;
        const isUp = stock.price >= prevPrice;
        const color = isUp ? '#f44336' : '#4caf50';
        const percent = prevPrice === 0 ? 0 : (((stock.price - prevPrice) / prevPrice) * 100).toFixed(1);

        return (
          <div key={key} style={{ background: '#1a1a1a', padding: 12, borderRadius: 8, display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ fontSize: 15, fontWeight: 'bold', color: '#fff' }}>{stock.name}</div>
              <div style={{ fontSize: 18, fontWeight: 'bold', color }}>¥ {stock.price}</div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 5, fontSize: 12, color: '#aaa' }}>
              <div>持仓: <span style={{ color: state.portfolio[key] > 0 ? '#ff9800' : '#888' }}>{state.portfolio[key] || 0} 股</span></div>
              <div style={{ color }}>{isUp ? '▲' : '▼'} {Math.abs(percent)}%</div>
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
              <button style={{ flex: 1, padding: '6px 0', background: 'rgba(244,67,54,0.1)', color: '#f44336', border: '1px solid #f44336', borderRadius: 4, cursor: 'pointer' }} onClick={() => handleTrade(key, stock.price, 'buy')}>买入一手</button>
              <button style={{ flex: 1, padding: '6px 0', background: 'rgba(76,175,80,0.1)', color: '#4caf50', border: '1px solid #4caf50', borderRadius: 4, cursor: 'pointer' }} onClick={() => handleTrade(key, stock.price, 'sell')}>全仓卖出</button>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

// 📱 5. 设置 App
const modelsMap = {"gpt": "GPT", "safe": "右先生", "open": "开源社区", "capital": "资本至上"};
export const SettingsApp = ({ state }) => (
  <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
    <div style={styles.appTitle}>⚙️ 设置与复盘</div>
    <div style={{ flex: 1, overflowY: 'auto', scrollbarWidth: 'none', display: 'flex', flexDirection: 'column', gap: 20 }}>
      {/* ... 省略部分：原封不动把 settings 的渲染内容贴过来即可 ... */}
       <div>
         <div style={{ fontSize: 13, color: '#aaa', marginBottom: 10 }}>[ 关于本机 ]</div>
         <div style={styles.settingsPanel}>
           <div style={styles.settingsRow}><span>设备名称</span><span>码奸 OS Max</span></div>
           <div style={{ ...styles.settingsRow, borderBottom: 'none' }}><span>系统模式</span><span style={{ color: '#4caf50' }}>{modelsMap[state.model] || '离线'}</span></div>
         </div>
       </div>
    </div>
  </div>
);